import Auth from '../auth/Auth';
import OptionGroup from '../models/OptionGroup';
import { WebClient } from './WebClient'

class ApiOptionGroup extends WebClient {
    async getOptionGroups(): Promise<OptionGroup[]> {
        const url = "/option/group";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async updateOptionGroup(data: OptionGroup): Promise<OptionGroup> {
        return this.put("/option/group", data, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }
}

export default new ApiOptionGroup();
